// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".smart-search__operator.e-bg-gray-900{background:#eceef1!important}.smart-search__operator .e-toggle-switch.e-bg-brand-600{background:#3b82f6}.smart-search__operator .e-toggle-switch:not(.e-bg-brand-600){box-shadow:none!important;color:rgba(3,32,80,.34)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
